import { Autocomplete as MuiAutoComplete, AutocompleteProps as MuiAutoCompleteProps, Box } from '@mui/material';

interface AutoCompleteProps<T> {
  getOptionKey?: (option: T) => string | number;
}

function AutoComplete<
  T,
  Multiple extends boolean | undefined = undefined,
  DisableClearable extends boolean | undefined = undefined,
  FreeSolo extends boolean | undefined = undefined
>({ getOptionKey, ...others }: MuiAutoCompleteProps<T, Multiple, DisableClearable, FreeSolo> & AutoCompleteProps<T>) {
  const keyFn = getOptionKey ?? ((o: any) => o?.id ?? o);

  const isObject = (val: unknown): val is Record<string, any> => typeof val === 'object' && val !== null && !Array.isArray(val);

  const isArrayOfObjects = (val: any): val is object[] => Array.isArray(val) && val.every(isObject);

  const isSingleObject = (val: any): val is object => !Array.isArray(val) && isObject(val);

  const shouldApplyCustomEquality =
    Array.isArray(others.options) && others.options.some(isObject) && (isSingleObject(others.value) || isArrayOfObjects(others.value));

  return (
    <MuiAutoComplete
      renderOption={(props, option) => (
        <Box component="li" {...props} key={keyFn(option)}>
          {others.getOptionLabel?.(option)}
        </Box>
      )}
      isOptionEqualToValue={shouldApplyCustomEquality ? (option, value) => keyFn(option) === keyFn(value) : undefined}
      {...others}
    />
  );
}

export default AutoComplete;
